import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import useMobile from 'hooks/useMobile';
import AuthContext from 'contexts/auth/context';
import usePermissions from 'hooks/usePermissions';
import ContextualMenu from 'components/ContextualMenu';
import { IContextualAction } from 'components/ContextualMenu/types';
import { managementRoles } from 'constants/roles';
import { IMoreActions } from './types';
import useActionHandlers from './useActionHandlers';

export const MoreActions: React.FC<IMoreActions> = (props: IMoreActions) => {
  const { open, anchorEl, handleClose, onHold, showOnHoldHeader, handleMenuClick } = props;

  const { t } = useTranslation();
  const { isMobileView } = useMobile();
  const { checkPermission } = usePermissions();
  const actionHandlers = useActionHandlers(handleMenuClick, handleClose);
  const { allowsManualOnHold } = useContext(AuthContext);
  checkPermission(managementRoles);

  const actions: IContextualAction[] = [
    {
      label: t('discussionKebabMobile'),
      iconClasses: 'fa-regular fa-screen-users',
      shouldHide: !isMobileView,
      onClick: actionHandlers.internalDiscussion,
    },
    {
      label: t('transfer'),
      iconClasses: 'fa-solid fa-share',
      shouldHide: !isMobileView,
      onClick: actionHandlers.transfer,
    },
    {
      label: onHold && showOnHoldHeader ? t('resumeOnHold') : t('putChatOnHold'),
      iconClasses: 'fa-regular fa-circle-pause',
      shouldHide: !allowsManualOnHold || isMobileView,
      onClick: actionHandlers.onHold,
    },
    {
      label: t('searchInChat'),
      iconClasses: 'fa-regular fa-magnifying-glass',
      shouldHide: isMobileView,
      onClick: actionHandlers.search,
    },
    {
      label: t('exportToPDF'),
      iconClasses: 'fa-solid fa-file-pdf',
      showDivider: false,
      shouldHide: !checkPermission(managementRoles),
      onClick: actionHandlers.exportToPDF,
    },
    {
      label: t('chatHistory'),
      iconClasses: 'fa-solid fa-clock-rotate-left',
      showDivider: true,
      shouldHide: isMobileView,
      onClick: actionHandlers.history,
    },
    {
      label: t('closeChatMobile'),
      iconClasses: 'fa-solid fa-close',
      showDivider: true,
      shouldHide: !isMobileView,
      onClick: actionHandlers.finish,
    },
  ];

  return <ContextualMenu anchorEl={anchorEl} open={open} actions={actions} onClose={handleClose} />;
};
